// tslint:disable
export var SystemStatus;
(function (SystemStatus) {
    // OTH
    SystemStatus[SystemStatus["OTHER"] = 0] = "OTHER";
    // Open
    SystemStatus[SystemStatus["Open"] = 1] = "Open";
    // Closed
    SystemStatus[SystemStatus["Closed"] = 2] = "Closed";
})(SystemStatus || (SystemStatus = {}));
SystemStatus['OPEN'] = 1;
SystemStatus['CLOSED'] = 2;
//# sourceMappingURL=SystemStatus.js.map